// ----------------------------------------------------------------------------
//   Imports
// ----------------------------------------------------------------------------


// React
import { forwardRef } from "react";

// Material UI
import {
  Box,
  Button,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";



// ----------------------------------------------------------------------------
//   Main Component
// ----------------------------------------------------------------------------


export const SelectionWithActionButton = forwardRef((
  {
    children,
    fallback = "-",
    icon,
    onClick,
  },
  ref
) => {

  // Shared styles
  const border = "1px solid lightgray";

  // Component layout
  return (
    <Stack
      ref = { ref }
      direction  = "row"
      alignItems = "center"
      sx={{
        "width": "100%",
        "outline": border,
        "borderRadius": "4px",
        "boxShadow": "inset 0 0 2px lightgray",
      }}
    >

      {/* Label */}
      <Box
        flexGrow={1}
        sx={{
          borderRight: border,
          paddingY:    2,
          paddingX:    3,
          fontFamily:  "monospace",
        }}
      >
        { children ?? fallback }
      </Box>

      {/* Action Button */}
      <IconButton
        onClick={ onClick }
        sx={{
          borderRadius: 0,
          // backgroundColor: "#4447ad",
          // color: "white",
        }}
      >
        { icon }
      </IconButton>
    </Stack>
  )
})



// ----------------------------------------------------------------------------
//   Export(s)
// ----------------------------------------------------------------------------

export default SelectionWithActionButton;
